import { Box, Typography } from '@mui/material';
import React from 'react';
import EllipsisText from '../../common/components/EllipsisText';
import { type QuickAddPerson } from '../../person/helpers/QuickAddPerson';

export type PersonOption = Pick<QuickAddPerson, 'id' | 'label' | 'name' | 'role' | 'email'> & {
    createOption?: boolean;
    professionalRoles?: string[];
};

export interface PersonOptionRendererProps {
    option: PersonOption;

    /**
     * Whether to show the email of the person in the option.
     */
    showEmail?: boolean;
    /**
     * Whether to show role/professional roles line in the option.
     */
    showRole?: boolean;
}

export default function PersonOptionRenderer({
    option,
    showEmail = false,
    showRole = true
}: PersonOptionRendererProps) {
    const createOption = option && option.createOption;
    const label = createOption ? `Add ${option.label}` : option.label;

    return (
        <Box key={option.id}>
            {createOption ? (
                <Typography color="text.primary" sx={{ fontStyle: createOption ? 'italic' : 'normal' }}>
                    {label}
                </Typography>
            ) : (
                <>
                    <Typography sx={{ fontWeight: 'medium' }} variant="subtitle1">
                        {option?.name}
                    </Typography>
                    {showRole && (
                        <Typography sx={{ fontWeight: '300' }} color="textDisabled" variant="subtitle2">
                            <EllipsisText text={option?.professionalRoles?.join(', ') || option.role || ' '} />
                        </Typography>
                    )}
                    {showEmail && option?.email && (
                        <Typography sx={{ fontWeight: '300' }} color="textDisabled" variant="subtitle2">
                            <EllipsisText text={option.email} />
                        </Typography>
                    )}
                </>
            )}
        </Box>
    );
}
